import { render, staticRenderFns } from "./productService.vue?vue&type=template&id=2c32d1d7&scoped=true"
import script from "./productService.vue?vue&type=script&lang=js"
export * from "./productService.vue?vue&type=script&lang=js"
import style0 from "./productService.vue?vue&type=style&index=0&id=2c32d1d7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32d1d7",
  null
  
)

export default component.exports